var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import mc from "@irati-web/payments/src/images/mastercard.svg";
import visa from "@irati-web/payments/src/images/visa.svg";
import amex from "@irati-web/payments/src/images/amex.svg";
var icons = {
    mc: mc,
    amex: amex,
    visa: visa
};
var Payment = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: url(", ");\n"], ["\n  background: url(", ");\n"])), function (_a) {
    var type = _a.type;
    return icons[type];
});
export default Payment;
var templateObject_1;
